import { defaultVariantIcon } from '../icons';
import { DEFAULT_CSS_CLASS } from '@constants';

const defaultBlockCssClass = DEFAULT_CSS_CLASS.BUTTON;

const simpleButton = {
  name: 'button-with-title',
  title: 'Simple Button',
  icon: defaultVariantIcon,
  scope: ['block'],
  attributes: {
    blockClassNames: [
      {
        value: `${defaultBlockCssClass}--primary`,
        label: 'Primary',
      },
    ],
  },
  innerBlocks: [
    [
      'core/paragraph',
      {
        className: 'title',
        content: 'Button Text',
        placeholder: 'Add Button Title',
      },
    ],
  ],
};

export default simpleButton;
